import { OptionalAssets, SupportedCurrencies } from '@monorepo/types';

export enum CreditEventType {
  ReceivedCredit = 'received_credit',
  ExpiringCredit = 'expiring_credit',
}

export interface CreditCartAsset {
  asset: OptionalAssets;
  assetLabel: string;
  groupName?: string;
  buyingPower?: number;
  totalPrice: number;
  tradingSystemLabel: string;
  currency: SupportedCurrencies;
}

export interface CreditsEventsModalProps {
  type: CreditEventType;
  open: boolean;
  onClose: () => void;
  /** e.g. open balance / credit history — parent may persist seen state */
  onViewCreditHistory?: () => void;
  creditAmount: number;
  onRedeem?: () => void;
  cartAssets?: CreditCartAsset[];
  onRedeemForAsset?: (asset: OptionalAssets) => void;
}
